"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.listForeignKeyOptions = exports.generate = void 0;
var Stateful = __importStar(require("@nexys/react-stateful"));
var U = __importStar(require("../utils"));
var mockList = function (input, entityMockData) {
    var mockData = entityMockData
        ? entityMockData[input.name]
        : undefined;
    if (!mockData)
        return Promise.resolve([]);
    if (mockData.list) {
        return Promise.resolve(mockData.list.map(function (md) {
            return U.addMockForeignData(md, U.getForeignEntityFields(input.fields), entityMockData);
        }));
    }
    return Promise.resolve([]);
};
var mockDetail = function (input, entityMockData) {
    var mockData = entityMockData
        ? entityMockData[input.name]
        : undefined;
    if (mockData) {
        if (mockData.detail) {
            return Promise.resolve(U.addMockForeignData(mockData.detail, U.getForeignEntityFields(input.fields), entityMockData));
        }
        if (mockData.list && mockData.list.length) {
            return Promise.resolve(U.addMockForeignData(mockData.list[0], U.getForeignEntityFields(input.fields), entityMockData));
        }
    }
    throw Error('no mock data specified');
};
var mockInsert = function (uuid) {
    return Promise.resolve(uuid ? { uuid: 'uuid1' } : { id: 1 });
};
var mockUpdate = function () { return Promise.resolve(true); };
var mockDelete = function () { return Promise.resolve(true); };
exports.generate = function (input, apiUrl, withBackend, mockData) {
    var projection = U.generateProjection(input.fields);
    var mutateUrl = apiUrl.replace(/query/, 'mutate');
    if (input.uuid) {
        var C_1 = new Stateful.RequestUtil.Crud.withUuid(String(input.name), apiUrl, mutateUrl);
        return {
            list: function () {
                if (withBackend === false) {
                    return mockList(input, mockData);
                }
                return C_1.list({ projection: projection });
            },
            detail: function (id) {
                if (withBackend === false) {
                    return mockDetail(input, mockData);
                }
                return C_1.detail({ uuid: String(id) }, projection);
            },
            deleteById: function (id) {
                if (withBackend === false) {
                    return mockDelete();
                }
                return C_1.deleteByUuid(String(id));
            },
            insert: function (data) {
                if (withBackend === false) {
                    return mockInsert(true);
                }
                return C_1.insertByUuid(data);
            },
            update: function (data) {
                if (withBackend === false) {
                    return mockUpdate();
                }
                return C_1.updateByUuid(data);
            }
        };
    }
    var C = new Stateful.RequestUtil.Crud.withId(String(input.name), apiUrl, mutateUrl);
    return {
        list: function () {
            if (withBackend === false) {
                return mockList(input, mockData);
            }
            return C.list({ projection: projection });
        },
        detail: function (id) {
            if (withBackend === false) {
                return mockDetail(input, mockData);
            }
            return C.detail({ id: Number(id) }, projection);
        },
        deleteById: function (id) {
            if (withBackend === false) {
                return mockDelete();
            }
            return C.deleteById(id);
        },
        insert: function (data) {
            if (withBackend === false) {
                return mockInsert(false);
            }
            return C.insertById(data);
        },
        update: function (data) {
            if (withBackend === false) {
                return mockUpdate();
            }
            return C.updateById(data);
        }
    };
};
exports.listForeignKeyOptions = function (input, apiUrl, withBackend, mockData) { return __awaiter(void 0, void 0, void 0, function () {
    var entityName, mutateUrl, re_1, C_2, re_2, C, re;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                entityName = String(input.name);
                mutateUrl = apiUrl.replace(/query/, 'mutate');
                if (!(withBackend === false)) return [3, 2];
                return [4, mockList(input, mockData)];
            case 1:
                re_1 = _a.sent();
                return [2, re_1.map(function (d) {
                        return input.uuid ? U.toUOptionSet(d) : U.toOptionSet(d);
                    })];
            case 2:
                if (!input.uuid) return [3, 4];
                C_2 = new Stateful.RequestUtil.Crud.withUuid(entityName, apiUrl, mutateUrl);
                return [4, C_2.list()];
            case 3:
                re_2 = _a.sent();
                return [2, re_2.map(function (d) { return U.toUOptionSet(d); })];
            case 4:
                C = new Stateful.RequestUtil.Crud.withId(entityName, apiUrl, mutateUrl);
                return [4, C.list()];
            case 5:
                re = _a.sent();
                return [2, re.map(function (d) { return U.toOptionSet(d); })];
        }
    });
}); };
